import { ResultSection } from 'aem-libs-react-components/src/components/calculators/components/result-section'
import { useDynamicParams } from 'aem-libs-react-ts/src/hooks/useDynamicParams'
import LanguageDetector from 'aem-libs-react-ts/src/services/LanguageDetector'

import type { LoansConsolidationParams } from '../types'

const lang = LanguageDetector()

export const CtaButtons = ({ testId }: { testId: string }) => {
  const params = useDynamicParams<LoansConsolidationParams>()
  return (
    <ResultSection.Cta
      testId={testId}
      items={[
        {
          label: params.ctaLabel[lang],
          showButton: true,
          items: [
            {
              href: params.callMeButton.url[lang],
              label: params.callMeButton.label[lang],
              type: 'callMe',
              showButton: params.callMeButton.showButton
            },
            {
              href: params.orderOnBranchButton.url[lang],
              label: params.orderOnBranchButton.label[lang],
              type: 'branchArrange',
              showButton: params.orderOnBranchButton.showButton
            }
          ]
        }
      ]}
    />
  )
}
